import { IBeneficiaryGroup, IBeneficiaryGroupDetails } from "../../models/beneficiary-groups/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import { BeneficiaryGroupLoading, IInternalState } from "./context";
import paramsReducer, { QueryAction } from "../base/base-reducer";

type Action =
  | {
      type: "LOADING";
      payload: { loading: BeneficiaryGroupLoading | BeneficiaryGroupLoading[] };
    }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IBeneficiaryGroup> } }
  | { type: "SET_DETAILSS"; payload: { details?: IBeneficiaryGroupDetails } }
  | QueryAction<any>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    case "SET_LIST":
      return {
        ...state,
        list: action.payload.list,
      };
    case "SET_DETAILSS":
      return {
        ...state,
        details: action.payload.details,
      };
    default:
      return paramsReducer(state, action);
  }
};

export default reducer;
